var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-col",
    { attrs: { cols: "6" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: _vm.showJurusan ? 6 : 12 } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Jenjang Pendidikan",
                    description: "Filter data berdasarkan Jenjang Pendidikan",
                  },
                },
                [
                  _c("v-select", {
                    attrs: {
                      value: _vm.filter.jenjang_pendidikan_id,
                      options: _vm.lists.jenjang,
                      label: "text",
                      reduce: (item) => item.value,
                      placeholder: "-- Pilih Jenjang --",
                    },
                    on: { input: _vm.onJenjang },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.showJurusan
            ? _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Jurusan",
                        description: "Filter data berdasarkan Jurusan",
                      },
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          value: _vm.filter.jurusan_id,
                          options: _vm.lists.jurusan,
                          label: "text",
                          reduce: (item) => item.value,
                          placeholder: "-- Pilih Jurusan --",
                        },
                        on: { input: _vm.onJurusan },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }